import React, { useEffect, useState } from "react";
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from "@mui/material";

const CustomRadioGroup = (props) => {
	const { label, onSelectRadioButton, onLoad } = props;
	const [selectedValue, setSelectedValue] = useState("");

	useEffect(() => {
		if (onLoad !== undefined && onLoad !== null) {
			setSelectedValue(onLoad);
		}
	}, [onLoad]);

	const handleRadioChange = (event) => {
		setSelectedValue(event.target.value);
		onSelectRadioButton(event.target.value);
	};

	return (
		<FormControl component="fieldset">
			<FormLabel component="legend">{label}:</FormLabel>
			<RadioGroup value={selectedValue} onChange={handleRadioChange}>
				<FormControlLabel value="true" control={<Radio />} label="True" />
				<FormControlLabel value="false" control={<Radio />} label="False" />
			</RadioGroup>
		</FormControl>
	);
};

export default CustomRadioGroup;
